import React from "react";
import { NavLink } from "react-router-dom";
import funelyMark from "assets/images/funely-mark.svg";

export const NavBarBrand = () => {
  return (
    <div className="nav-bar__brand">
      <NavLink to="/">
        <img
          className="nav-bar__logo"
          src={funelyMark}
          alt="Funely"
          width="122"
          height="36"
        />
      </NavLink>
    </div>
  );
};
